export default "__VITE_ASSET__CRglbzyd__"